import React, { Component } from 'react'
import Copy from 'copy-to-clipboard'
import { Clipboard, Heart } from 'react-feather'
import { Button } from '@/components/ui/button'

import ButtonTooltip from './ButtonTooltip'
import logger from './Logger'

import '../App.css'

class CopyToClipboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            copied: false,
        }
        this.onCopy = this.onCopy.bind(this)
        this.onCopyText = this.onCopyText.bind(this)
        this.onCopyImage = this.onCopyImage.bind(this)
    }

    onCopy(event) {
        if (this.props.text && this.props.text.length > 0) {
            this.onCopyText(this.props.text)
        }
        else if (this.props.image) {
            this.onCopyImage(this.props.image)
        }
    }
    onCopyText() {
        const self = this
        try {

            // copy
            Copy(self.props.text, {
                debug: true,
            })

            // change the icon
            self.setState(Object.assign({}, self.state, {
                copied: true,
            }))

            // call the callback if it exists
            if (self.props.onCopy) {
                self.props.onCopy()
            }

        }
        catch(e) {
            // console.log(e) // ignore
        }

        setTimeout(() => {
            // reset the icon
            self.setState(Object.assign({}, self.state, {
                copied: false,
            }))
        }, 700)
    }
    onCopyImage() {
        var data = new Blob(["Text data"], {type : "text/plain"})
        navigator.clipboard.write(data).then(function() {
            logger.info("Copied to clipboard successfully!")
        }, function() {
            logger.warn("Unable to write to clipboard")
        })
    }

    render() {
        const disabled = !this.props.text || this.props.text.length === 0

        let button
        if (this.state.copied) {
            button = <Heart className={ 'icon-xs card-head-button' + (this.props.className ? " " + this.props.className : '') } />
        }
        else if (disabled) {
            button = <Clipboard className={ 'icon-xs card-head-button icon-button App-disabled' + (this.props.className ? " " + this.props.className : '') } />
        }
        else {
            button = <Clipboard className={ 'icon-xs card-head-button icon-button' + (this.props.className ? " " + this.props.className : '') } />
        }

        const variant = this.props.noOutline ? "ghost" : "outline"

        return <ButtonTooltip tooltipMessage={ this.props.tooltipMessage || "Copy to clipboard" } placement={ this.props.tooltipPlacement || "top" }>
            <Button
                variant={ variant }
                onClick={ this.onCopy }
                size="icon-sm"
                className={ "card-head-button" }
                disabled={ disabled }>{ button }</Button>
        </ButtonTooltip>
    }
}

export default CopyToClipboard
